import { render, staticRenderFns } from "./AudioOrAutomatedPanel.vue?vue&type=template&id=22165664&scoped=true&"
import script from "./AudioOrAutomatedPanel.vue?vue&type=script&lang=js&"
export * from "./AudioOrAutomatedPanel.vue?vue&type=script&lang=js&"
import style0 from "./AudioOrAutomatedPanel.vue?vue&type=style&index=0&id=22165664&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22165664",
  null
  
)

export default component.exports